
import { Component, Mixins } from 'vue-mixin-decorator';
import DPC from '@/components/mixin/DesignPathCreator.vue';

import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component
export default class BaseView extends Mixins<DPC>(DPC) {
  get paths() {
    return this.$store.state.routerPath;
  }

  get storedExam() {
    return this.$store.state.exam;
  }

  /**
   * 検定固有のconfig.css取得処理
   */
  // eslint-disable-next-line class-methods-use-this
  async getExamConfigCss() {
    let cssPath = '';

    if (this.storedExam !== null && this.storedExam.resources !== undefined) {
      cssPath = this.createCssPath(this.storedExam.resources);
    } else {
      const ExamRepository = RepositoryFactory.get().exam;
      await ExamRepository.getExam().then((response: any) => {
        if (response.status === 200 && response.data.resources !== undefined) {
          cssPath = this.createCssPath(response.data.resources);
        }
      });
    }

    const ConfigCss = document.createElement('link');
    ConfigCss.rel = 'stylesheet';
    ConfigCss.href = cssPath;
    return ConfigCss;
  }

  /**
   * リソース情報からCSSのパスを生成する
   * @param resources リソース情報
   * @return CSSパス
   */
  // eslint-disable-next-line class-methods-use-this
  private createCssPath(resources: any): string {
    let retPath = '';
    resources.forEach((resource: any) => {
      const key = resource.display_place_key;
      if (key === 'COLOR_CSS') {
        retPath = StringUtil.isEmpty(resource.resource_uri) ? '' : `/${resource.resource_uri}`;
      }
    });
    return retPath;
  }
}
